module.exports = __webpack_public_path__ + "img/order.08e5a6f5.svg";